declare global {
  interface Window {
    DD_LOGS: {
      logger: {
        warn: (message: string, context: Record<string, unknown>) => void;
      };
    };
  }
}

export const logError = (
  component: string,
  message: string,
  failurePoint: string,
): void => {
  if (typeof window !== 'undefined' && window.DD_LOGS) {
    window.DD_LOGS.logger.warn(`${component}: ${message}`, {
      failurePoint,
    });
  }
};
